import script from "./Print_button.vue?vue&type=script&setup=true&lang=js"
export * from "./Print_button.vue?vue&type=script&setup=true&lang=js"

import "./Print_button.vue?vue&type=style&index=0&id=5154f4da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5154f4da"]])

export default __exports__